import React, { useCallback, useMemo } from 'react';
  import { notification } from 'antd';
  import type { NotificationArgsProps } from 'antd';

  
  type NotificationPlacement = NotificationArgsProps['placement'];
  type NotificationType = 'success' | 'info' | 'warning' | 'error';
  
export const NotificationContext = React.createContext<{
    triggerNotification: (type: NotificationType, message: string, description: string, placement: NotificationPlacement) => void;
  }>({
    triggerNotification: () => {},
  });
  

export const NotificationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [api, contextHolder] = notification.useNotification();
  
    const triggerNotification = useCallback(
        (type: NotificationType, message: string, description: string, placement: NotificationPlacement) => {
          api[type]({
            message,
            description,
            placement,
          });
        },
        [api]
      );
  
    const contextValue = useMemo(() => ({ triggerNotification }), [triggerNotification]);
  
    return (
      <NotificationContext.Provider value={contextValue}>
        {contextHolder}
        {children}
      </NotificationContext.Provider>
    );
  };

